import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ProvidersModelService} from '../../../Models/Purchases/Providers/providers-model.service';
import {ProviderContactStoreForm} from '../../../../Models/Purchases/Providers/provider-contact-store.model';
import {ProviderProductStoreForm} from '../../../../Models/Purchases/Providers/provider-product-store.model';
import {PurchaseFormat} from '../../../../Models/Purchases/Providers/purchase-format.interface';
import {FavoriteProductProviderDto} from '../../../../Models/Purchases/Providers/favorite-product-provider.interface';
import {PurchaseFormatsModelService} from '../../../Models/Purchases/Products/purchase-formats-model.service';

@Injectable({
  providedIn: 'root'
})
export class ProvidersApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ProvidersModelService,
    public purchaseFormatsModel: PurchaseFormatsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los proveedores
   *
   */
  public getProviders(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProveedores', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los datos de un proveedor
   *
   */
  public getProviderDetail(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los productos de un proveedor
   *
   */
  public getProviderProducts(params: { id: number, id_proveedor: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductosProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener el catálogo del proveedor
   *
   */
  public getProviderCatalog(params: { id_local: number, id_proveedor: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getCatalogoProveedor', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Marcar/Desmarcar favorito un producto de un proveedor
   *
   */
  public setFavoriteProviderProducts(params: FavoriteProductProviderDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setProductoFavorito', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir/editar proveedor
   *
   */
  public setProvider(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Elimianr proveedor
   *
   */
  public deleteProvider(params: { id?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir/editar un contacto de un proveedor
   *
   */
  public setProviderProduct(params: ProviderProductStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setProductoProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar un producto de un proveedor
   *
   */
  public deleteProviderProduct(params: { id_pcp: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteProductoProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir/editar un contacto de un proveedor
   *
   */
  public setProviderContact(params: ProviderContactStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setContactoProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar un contacto de un proveedor
   *
   */
  public deleteProviderContact(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteContactoProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los formatos de compra
   *
   */
  public getPurchaseFormats(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('purchase-formats', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.purchaseFormatsModel.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los formatos de compra múltiplos
   *
   */
  getMultiplePurchaseFormats(): PurchaseFormat[] {
    return [
      {id: 1, nombre: this.translate.instant('CONST.PURCHASE_FORMATS.BOX'), simbolo: 'CJ'},
      {id: 2, nombre: this.translate.instant('CONST.PURCHASE_FORMATS.SACK'), simbolo: 'SC'},
      {id: 3, nombre: this.translate.instant('CONST.PURCHASE_FORMATS.ROLL'), simbolo: 'RLL'},
      {id: 4, nombre: this.translate.instant('CONST.PURCHASE_FORMATS.PACKAGE'), simbolo: 'PQT'},
    ];
  }


  /**
   * Añadir el formato de compra guardado al listado si no coincide con ninguno
   *
   */
  appendUnmatchedPurchaseFormat(formats: PurchaseFormat[], value?: string): PurchaseFormat[] {

    if (!value || formats.some((format) => format.nombre === value)) {
      return formats;
    }

    return [...formats, {id: -1, nombre: value, simbolo: ''}];
  }

}
